// const apiUrl = 'https://doc.haiweikexin.com/mock/137/api/v1/';//测试域名
const uniUrl = 'http://192.168.0.83:8080/';//测试域名
// const apiUrl = 'http://192.168.0.192:3000/mock/74/';//测试域名
// const apiUrl = 'http://192.168.0.7:8303/api/v1/';//测试域名
// const apiUrl = 'http://192.168.0.31:9501/api/v1/';//测试域名

export default uniUrl



// WEBPACK FOOTER //
// ./src/util/uniUrl.js